import namespace from '@/utils/namespace'

export default namespace('global', {
  getters: [
    'loading'
  ],
  mutations: [
    'startProcessing',
    'stopProcessing'
  ]
})
